import COLORS from "../colors";

export default theme => ({
  main: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    boxSizing: "border-box",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    fontFamily: theme.typography.fontFamily,
    backgroundColor: "#fff",
    backgroundImage:
      "linear-gradient(rgba(10, 40, 70, 0.35), rgba(10, 40, 70, 0.35)), url(/images/loginBackground.jpg)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  card: {
    width: "100%",
    maxWidth: 440,
    boxSizing: "border-box",
    padding: "28px 28px 32px",
    borderRadius: 20,
    backgroundColor: "#fff",
    boxShadow: "0 12px 24px rgba(10, 40, 70, 0.2)"
  },
  logo: {
    display: "block",
    width: 220,
    maxWidth: "100%",
    margin: "0 auto 20px"
  },
  title: {
    margin: 0,
    color: COLORS.text,
    fontSize: 26,
    fontWeight: 700
  },
  subtitle: {
    margin: "4px 0 24px",
    color: COLORS.muted,
    fontSize: 15
  },
  fieldWrap: {
    marginBottom: 16
  },
  label: {
    display: "block",
    marginBottom: 6,
    color: COLORS.text,
    fontSize: 14,
    fontWeight: 600
  },
  fieldIcon: {
    flexShrink: 0,
    color: COLORS.muted,
    fontSize: 20
  },
  field: {
    display: "flex",
    alignItems: "center",
    height: 52,
    boxSizing: "border-box",
    padding: "0 14px",
    border: `1px solid ${COLORS.border}`,
    borderRadius: 12,
    backgroundColor: COLORS.field,
    "&:focus-within": {
      borderColor: COLORS.primary,
      backgroundColor: "#fff"
    },
    "&:focus-within $fieldIcon": {
      color: COLORS.primary
    }
  },
  fieldError: {
    borderColor: COLORS.error
  },
  input: {
    flex: 1,
    minWidth: 0,
    height: "100%",
    marginLeft: 12,
    padding: 0,
    border: 0,
    outline: 0,
    background: "transparent",
    color: COLORS.text,
    fontFamily: "inherit",
    fontSize: 16,
    "&::placeholder": {
      color: COLORS.muted,
      opacity: 1
    },
    // keep the browser's autofill colour from covering the field
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 40px ${COLORS.field} inset`,
      WebkitTextFillColor: COLORS.text
    }
  },
  visibilityButton: {
    display: "flex",
    flexShrink: 0,
    marginLeft: 8,
    padding: 4,
    border: 0,
    borderRadius: 6,
    background: "transparent",
    color: COLORS.muted,
    cursor: "pointer",
    "&:hover, &:focus": {
      color: COLORS.primary,
      outline: 0
    }
  },
  errorText: {
    marginTop: 6,
    color: COLORS.error,
    fontSize: 13
  },
  button: {
    height: 52,
    marginTop: 8,
    borderRadius: 12,
    backgroundColor: COLORS.primary,
    boxShadow: "none",
    color: "#fff",
    fontSize: 16,
    fontWeight: 700,
    textTransform: "none",
    "&:hover": {
      backgroundColor: COLORS.primaryPressed
    },
    "&:active": {
      boxShadow: "none"
    },
    "&:disabled": {
      backgroundColor: COLORS.primary,
      color: "#fff"
    }
  }
});
